export class AtlasOrganization {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "atlasOrganizationId",
            "baseName": "atlasOrganizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "AccountState",
            "format": ""
        },
        {
            "name": "accountCount",
            "baseName": "accountCount",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return AtlasOrganization.attributeTypeMap;
    }
    constructor() {
    }
}
